import {MutableRefObject, useEffect, useState} from 'react';

export default function useIsOverflowRef(element: MutableRefObject<HTMLElement>) {
  const [isWidthOverflow, setIsWidthOverflow] = useState(false);
  const [isHeightOverflow, setIsHeightOverflow] = useState(false);

  const el = element.current;

  useEffect(() => {
    const el = element.current;

    if (!el) return;

    const observer = new ResizeObserver(() => {
      setIsWidthOverflow(el.offsetWidth < el.scrollWidth);
      setIsHeightOverflow(el.offsetHeight < el.scrollHeight);
    });

    observer.observe(element.current);

    return () => observer.disconnect();
  }, [element, el]);

  return {isWidthOverflow, isHeightOverflow};
}
